import { g as getDateFromDatepicker } from './get-date-from-datepicker.js';
import './index3.js';

/**
 * ** Kruske Desarrollo Web **
 *
 * Example: <a href="https://www.hoteleuropasevilla.com/" target="_blank">Hotel Sevilla</a>
 *
 * @exports bs_74
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     *
     * Implements **noRooms**
     *
     * @memberOf module:bs_74
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    widgetData.dateBegin = getDateFromDatepicker('#formFechaIni');
    widgetData.dateEnd = getDateFromDatepicker('#formFechaFin');
    widgetData.adults = parseInt($('#formPersonas').val(), 10) || 2;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // PRICES
    const $prices = $('.precioCondi');
    if ($prices.length) {
      const prices = $prices.map(function (idx, el) {
        const string = $(el).text().trim();
        let price = thn.parseNumber(string);
        // security check
        if (price > 500) {
          // if price is higher than 500e
          // this *could* be an error so
          // parse directly, just in case
          const m = /\d+/.exec(string);
          price = m ? parseInt(m[0], 10) : Number.MAX_VALUE;
        }
        return price;
      }).toArray();

      widgetData.price = Math.min.apply(null, prices);
      widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.currency = 'EUR'; // fixed
      widgetData.set = true;

    } else if ($('.info-message.warning').length && $('.info-message.warning').html().match(/Sin resultado/)) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * Can't implement **bookingId**.
     *
     * @memberOf module:bs_74
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    let $aux;

    $aux = $('#formFechaIniGracias');
    if ($aux.length) {
      widgetData.dateBegin = $aux.val().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    $aux = $('#formFechaFinGracias');
    if ($aux.length) {
      widgetData.dateEnd = $aux.val().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    $aux = $('#formTotalGracias');
    if ($aux.length) {
      widgetData.price = $aux.val();
    }

    $aux = $('#formCurrencyGracias');
    if ($aux.length) {
      widgetData.currency = $aux.val();
    }

    return widgetData;
  };

  return engine;

}

export { factory };
